
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/organization",
      function () {
        return require("private-next-pages/ir/governance/organization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/governance/organization"])
      });
    }
  